// extracted by mini-css-extract-plugin
export default {"painted-door":"PNRsNw1M86lpkDXoUxEi","header":"SkBePWJfMLXT6Lfwrx_R"};